const SHIPPING_VARIANTS = {
  300: 58307937370444,
  350: 58307937403212,
  450: 58307937435980,
  500: 58307937468748,
  550: 58307937501516,
  650: 58307937534284,
  700: 58307937567052,
  750: 58307937599820,
  800: 58307937632588,
  850: 58307937665356,
  900: 58307937698124,
  950: 58307937730892,
  1000: 58307937763660,
  1100: 58307937796428,
  1300: 58307937829196,
  1500: 58307937861964,
  1600: 58307937894732,
  2000: 58307937927500
};

class MiraCustomCheckout {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-checkout-form]');

    if (!this.form) {
      return;
    }

    this.rates = window.MIRA_WILAYA_RATES || {};
    this.config = window.MiraCheckoutConfig || {};

    this.wilayaSelect = root.querySelector('[data-wilaya-select]');
    this.deliveryBlock = root.querySelector('[data-delivery-block]');
    this.deliveryInputs = root.querySelectorAll('[data-delivery-method]');

    this.officeOption = root.querySelector('[data-office-option]');
    this.homeOption = root.querySelector('[data-home-option]');

    this.officePrice = root.querySelector('[data-office-price]');
    this.homePrice = root.querySelector('[data-home-price]');
    this.delay = root.querySelector('[data-delivery-delay]');

    this.shippingTotal = root.querySelector('[data-shipping-total]');
    this.grandTotal = root.querySelector('[data-grand-total]');

    this.error = root.querySelector('[data-checkout-error]');
    this.submitButton = root.querySelector('[data-checkout-submit]');

    this.currentWilaya = null;

    this.populateWilayas();
    this.bindEvents();
    this.restoreSavedData();
  }

  populateWilayas() {
    Object.entries(this.rates).forEach(([code, wilaya]) => {
      const option = document.createElement('option');

      option.value = code;
      option.textContent = `${code} — ${wilaya.name}`;

      this.wilayaSelect.appendChild(option);
    });
  }

  bindEvents() {
    this.wilayaSelect.addEventListener('change', () => {
      this.selectWilaya(this.wilayaSelect.value);
    });

    this.deliveryInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateTotals();
      });
    });

    this.form.addEventListener('submit', async (event) => {
      event.preventDefault();
      await this.submit();
    });
  }

  async restoreSavedData() {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        return;
      }

      const cart = await response.json();
      const attributes = cart.attributes || {};

      const code = attributes['Code wilaya'];

      if (code && this.rates[code]) {
        this.wilayaSelect.value = code;
        this.selectWilaya(code);

        const savedMethod =
          attributes['Mode de livraison'] === 'À domicile'
            ? 'home'
            : 'office';

        this.selectMethod(savedMethod);
        this.updateTotals();
      }
    } catch (error) {
      console.warn('Impossible de restaurer les données.', error);
    }
  }

  setField(name, value) {
    const field = this.root.querySelector(
      `[data-field="${name}"]`
    );

    if (field && value) {
      field.value = value;
    }
  }

  selectWilaya(code) {
    this.hideError();

    if (!code || !this.rates[code]) {
      this.currentWilaya = null;
      this.deliveryBlock.hidden = true;
      this.resetTotals();
      return;
    }

    this.currentWilaya = {
      code,
      ...this.rates[code]
    };

    this.officePrice.textContent = this.formatNumber(
      this.currentWilaya.office
    );

    this.homePrice.textContent = this.formatNumber(
      this.currentWilaya.home
    );

    this.delay.textContent =
      this.currentWilaya.delay || 'À confirmer';

    const officeAvailable =
      this.currentWilaya.office !== null &&
      this.currentWilaya.office !== undefined;

    const homeAvailable =
      this.currentWilaya.home !== null &&
      this.currentWilaya.home !== undefined;

    this.officeOption.hidden = !officeAvailable;
    this.homeOption.hidden = !homeAvailable;

    const officeInput = this.root.querySelector(
      '[data-delivery-method][value="office"]'
    );

    const homeInput = this.root.querySelector(
      '[data-delivery-method][value="home"]'
    );

    officeInput.disabled = !officeAvailable;
    homeInput.disabled = !homeAvailable;

    /*
     * Le bureau est sélectionné par défaut.
     * Si le bureau est indisponible, le domicile est sélectionné.
     */
    if (officeAvailable) {
      this.selectMethod('office');
    } else if (homeAvailable) {
      this.selectMethod('home');
    }

    this.deliveryBlock.hidden = false;
    this.updateTotals();
  }

  selectMethod(method) {
    const input = this.root.querySelector(
      `[data-delivery-method][value="${method}"]`
    );

    if (input && !input.disabled) {
      input.checked = true;
    }
  }

  getSelectedMethod() {
    return this.root.querySelector(
      '[data-delivery-method]:checked'
    )?.value;
  }

  getShippingPrice() {
    if (!this.currentWilaya) {
      return null;
    }

    const method = this.getSelectedMethod();

    if (!method) {
      return null;
    }

    return this.currentWilaya[method];
  }

  updateTotals() {
    const shippingPrice = this.getShippingPrice();

    if (
      shippingPrice === null ||
      shippingPrice === undefined
    ) {
      this.resetTotals();
      return;
    }

    const cartTotalCents =
      Number(this.config.cartTotalCents || 0);

    const shippingCents = shippingPrice * 100;
    const grandTotalCents = cartTotalCents + shippingCents;

    this.shippingTotal.textContent =
      `${this.formatNumber(shippingPrice)} DA`;

    this.grandTotal.textContent =
      `${this.formatNumber(grandTotalCents / 100)} DA`;
  }

  resetTotals() {
    this.shippingTotal.textContent = '—';

    const cartTotal =
      Number(this.config.cartTotalCents || 0) / 100;

    this.grandTotal.textContent =
      `${this.formatNumber(cartTotal)} DA`;
  }

 validate() {
  if (!this.currentWilaya) {
    this.showError('Veuillez sélectionner votre wilaya.');
    this.wilayaSelect.focus();
    return false;
  }

  const method = this.getSelectedMethod();

  if (!method) {
    this.showError(
      'Veuillez sélectionner un mode de livraison.'
    );
    return false;
  }

  return true;
}

async getCart() {
  const response = await fetch(
    `${window.Shopify.routes.root}cart.js`,
    {
      headers: {
        Accept: 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error(
      `Lecture du panier impossible : ${response.status}`
    );
  }

  return response.json();
}

isShippingItem(item) {
  return item.properties?._mira_shipping_fee === 'true';
}

async removeExistingShippingItems() {
  const cart = await this.getCart();

  const shippingItems = cart.items.filter((item) =>
    this.isShippingItem(item)
  );

  for (const item of shippingItems) {
    const response = await fetch(
      `${window.Shopify.routes.root}cart/change.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        `Suppression de l'ancien tarif impossible : ${response.status}`
      );
    }
  }
}

async addShippingItem(price, method) {
  const variantId = SHIPPING_VARIANTS[price];

  if (!variantId) {
    throw new Error(
      `Aucune variante configurée pour le tarif ${price} DA`
    );
  }

  const methodLabel =
    method === 'office'
      ? 'Au bureau'
      : 'À domicile';

  await this.removeExistingShippingItems();

  const response = await fetch(
    `${window.Shopify.routes.root}cart/add.js`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              _mira_shipping_fee: 'true',
              Wilaya: this.currentWilaya.name,
              'Mode de livraison': methodLabel,
              'Délai estimé': this.currentWilaya.delay || ''
            }
          }
        ]
      })
    }
  );

  if (!response.ok) {
    const message = await response.text();

    throw new Error(
      `Ajout de la livraison impossible : ${message}`
    );
  }

  return response.json();
}
  async submit() {
  this.hideError();

  if (!this.validate()) {
    return;
  }

  const method = this.getSelectedMethod();
  const shippingPrice = this.getShippingPrice();

  const methodLabel =
    method === 'office'
      ? 'Au bureau'
      : 'À domicile';

  this.submitButton.disabled = true;
  this.submitButton.textContent = 'Préparation…';

  try {
    /*
     * Ajoute au panier la variante Livraison correspondant
     * au tarif sélectionné.
     */
    await this.addShippingItem(
      shippingPrice,
      method
    );

    /*
     * Enregistre également les informations dans les
     * attributs du panier et dans la commande.
     */
    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            Wilaya: this.currentWilaya.name,
            'Code wilaya': this.currentWilaya.code,
            'Mode de livraison': methodLabel,
            'Tarif de livraison': `${shippingPrice} DA`,
            'Délai estimé': this.currentWilaya.delay || ''
            },
          note:
            `Livraison ${methodLabel} — ` +
            `${this.currentWilaya.name} — ` +
            `${shippingPrice} DA`
        })
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    window.location.href =
      `${window.Shopify.routes.root}checkout`;
  } catch (error) {
    console.error('Erreur Mira Checkout :', error);

    this.showError(
      'Le tarif de livraison n’a pas pu être ajouté. Vérifiez les variantes du produit Livraison.'
    );

    this.submitButton.disabled = false;
    this.submitButton.textContent =
      'Valider et continuer';
  }
}

  getFieldValue(name) {
    return (
      this.root.querySelector(`[data-field="${name}"]`)
        ?.value.trim() || ''
    );
  }

  formatNumber(value) {
    if (value === null || value === undefined) {
      return 'Indisponible';
    }

    return new Intl.NumberFormat('fr-DZ', {
      maximumFractionDigits: 0
    }).format(value);
  }

  showError(message) {
    this.error.textContent = message;
    this.error.hidden = false;
  }

  hideError() {
    this.error.hidden = true;
    this.error.textContent = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector(
    '[data-custom-checkout]'
  );

  if (root) {
    new MiraCustomCheckout(root);
  }
});